<template>
  <div>
    <Modal v-model="resDetailModal" width="60%" footer-hide>
      <p slot="header" class="text-center">管理资源</p>
      <Tabs v-model="curTab" @on-change="onChangeTab">
        <TabPane label="已配置资源" name="existRes">
          <div class="m-b-10">
            <Button type="error" size="small" :disabled="selectedExistResIds.length===0" @click="onDelRes">批量删除</Button>
          </div>
          <Table
            size="small"
            stripe
            max-height="520"
            :data="list"
            :columns="tableColumns"
             @on-selection-change="onSelectExist"
          ></Table>
          <div class="m-t-10">
            <span>总共已选择</span><span class="text-orange"> {{ list.length }} </span><span>条</span>
          </div>
        </TabPane>
        <TabPane label="选择资源" name="selectRes">
          <Row :gutter="6" class="m-b-5">
            <i-col span="3" class="m-b-5">
              <i-select
                size="small"
                v-model="assetId"
                @on-change="handleChangeAsset"
              >
                <Option :value="-1">全部资产</Option>
                <i-option
                  :value="item.id"
                  v-for="item in assetArray"
                  :key="item.id"
                  >{{ item.name }}</i-option
                >
              </i-select>
            </i-col>
            <i-col span="3" class="m-b-5">
              <i-select
                size="small"
                placeholder="所属项目"
                clearable
                v-model="query.projectId"
                @on-change="getPackageData"
              >
                <i-option
                  v-for="item in projectArray"
                  :key="'project_' + item.id"
                  :value="item.id"
                  >{{ item.name }}</i-option
                >
              </i-select>
            </i-col>
            <i-col span="3" class="m-b-5">
              <i-select
                size="small"
                placeholder="所属资产包"
                clearable
                v-model="query.packageId"
                :disabled="!query.projectId"
              >
                <i-option
                  v-for="item in packageArray"
                  :key="'package_' + item.id"
                  :value="item.id"
                  >{{ item.name }}</i-option
                >
              </i-select>
            </i-col>
            <i-col span="3" class="m-b-5">
              <i-select
                size="small"
                placeholder="站点（可通过关键字搜索）"
                clearable
                filterable
                v-model="query.stationId"
              >
                <i-option
                  :value="item.id"
                  v-for="item in stationArray"
                  :key="item.id"
                  >{{
                    assetId === -1
                      ? `${item.name} -
            ${item.assetName}`
                      : item.name
                  }}</i-option
                >
              </i-select>
            </i-col>
            <i-col span="3" class="m-b-5">
              <i-select
                size="small"
                placeholder="资源类型（可通过关键字搜索）"
                clearable
                filterable
                v-model="query.resourcetypeId"
              >
                <OptionGroup
                  v-for="item in resourceTypeArray"
                  :key="'re_parent_' + item.id"
                  :label="item.name"
                >
                  <Option
                    v-for="child in item.children"
                    :value="child.id"
                    :key="'re_child' + child.id"
                    >{{ child.name }}
                  </Option>
                </OptionGroup>
              </i-select>
            </i-col>
            <i-col span="2" class="m-b-5">
              <i-select
                size="small"
                placeholder="状态"
                clearable
                v-model="query.enabled"
              >
                <i-option
                  v-for="item in statusArray"
                  :key="'status_' + item.value"
                  :value="item.value"
                  >{{ item.name }}</i-option
                >
              </i-select>
            </i-col>

            <i-col span="3" class="m-b-5">
              <i-input
                size="small"
                placeholder="关键字：支持名称查询"
                v-model="query.keyword"
              ></i-input>
            </i-col>
            <i-col span="3" class="m-b-5">
              <i-button
                size="small"
                class="m-r-5"
                type="primary"
                icon="ios-search"
                @click="handleSearch()"
                >搜索</i-button
              >
            </i-col>
          </Row>
          <div>
            <div class="m-b-10">
              <i-button
                size="small"
                type="primary"
                :disabled="selectedItems.length === 0"
                @click="onBatchAdd"
                >批量加入</i-button
              >
            </div>
            <Table
              size="small"
              stripe
              max-height="520"
              :loading="resLoading"
              :data="reslist"
              :columns="showTableColumns"
              @on-selection-change="onSelection"
            ></Table>
            <div class="paging_style">
              <Page
                size="small"
                :total="resTotal"
                :page-size="query.pageSize"
                show-total
                show-elevator
                :current="query.pageNumber"
                @on-change="handlePageChange"
              ></Page>
            </div>
          </div>
        </TabPane>
      </Tabs>
    </Modal>
    <Modal v-model="editResModal" width="400">
      <p slot="header" class="text-center">编辑规格信息</p>
      <p class="m-b-10 text-orange">
        提示：常规媒体可以不用编辑，电子媒体根据实际情况进行编辑。
      </p>
      <Row :gutter="8" class="m-b-10">
        <i-col span="10">售卖规格（秒或天）</i-col>
        <i-col span="14">
          <InputNumber
            v-model="duration"
            :min="1"
            size="small"
            style="width: 100%"
            placeholder="最小售卖规格"
          >
          </InputNumber>
        </i-col>
      </Row>
      <Row :gutter="8" class="m-b-10">
        <i-col span="10">售卖周期数（次）</i-col>
        <i-col span="14">
          <InputNumber
            v-model="period"
            :min="1"
            size="small"
            style="width: 100%"
            placeholder="每天周期数"
          >
          </InputNumber>
        </i-col>
      </Row>
      <div slot="footer">
        <Button type="text" class="m-r-5" @click="editResModal = false"
          >取消</Button
        >
        <Button
          type="primary"
          @click="operate === 1 ? onConfirmAdd() : onConfirmEditSpec()"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  getComResource,
  deleteComResource,
  getResourcePage,
  getPackageList,
  addComResource,
  updateComResource
} from '@/api/product/resource'
import { getResourceTypeList } from '@/api/product/asset'
import { deviceResMixins } from '../mixins/index'

export default {
  props: {
    assetArray: {
      type: Array,
      required: true
    },
    projectArray: [Array]
  },
  mixins: [deviceResMixins],
  data () {
    return {
      resDetailModal: false,
      curComId: null,
      curTab: 'existRes',
      resourceTypeArray: [],
      list: [],
      tableColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '编号', align: 'center', key: 'code' },
        { title: '站点', align: 'center', key: 'stationName' },
        { title: '类型', align: 'center', key: 'resourcetypeName' },
        { title: '等级', align: 'center', key: 'levelName' },
        { title: '楼层', align: 'center', key: 'floor' },
        { title: '面积(㎡)', align: 'center', key: 'area' },
        {
          title: '制作尺寸(mm)',
          align: 'center',
          render: (h, params) => {
            return h(
              'span',
              `${params.row.makewidth} * ${params.row.makeheight}`
            )
          }
        },
        {
          title: '见光尺寸(mm)',
          align: 'center',
          render: (h, params) => {
            return h(
              'span',
              `${params.row.finalwidth} * ${params.row.finalheight}`
            )
          }
        },
        { title: '售卖规格（秒或天）', align: 'center', key: 'duration' },
        { title: '售卖周期数（次）', align: 'center', key: 'period' },
        {
          title: '状态',
          align: 'center',
          key: 'enabled',
          render: (h, params) => {
            const status = this.statusArray.find(
              (x) => x.value === params.row.enabled
            )
            return h('span', status ? status.name : '/')
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 120,
          render: (h, { row }) => {
            const html = [
              h(
                'a',
                {
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      this.onEditRes(row)
                    }
                  }
                },
                '编辑规格'
              )
              // h(
              //   'a',
              //   {
              //     style: { color: '#ef4f4f' },
              //     on: {
              //       click: () => {
              //         this.onDelRes(row)
              //       }
              //     }
              //   },
              //   '删除'
              // )
            ]
            return h('div', html)
          }
        }
      ],
      assetId: undefined,
      curExistRes: {},
      selectedExistResIds: [],
      operate: 1, // 1：新增，2：编辑
      query: {
        pageNumber: 1,
        pageSize: 15,
        assetId: null,
        // cityId: null,
        enabled: 1,
        fault: null,
        level: null,
        position: null,
        resource: null,
        resourcetypeId: null,
        stationId: null,
        keyword: '',
        status: null,
        deleted: undefined,
        open: undefined,
        projectId: undefined,
        packageId: undefined,
        notInComId: undefined
      },
      reslist: [],
      stationArray: [],
      statusArray: [
        { value: 1, name: '可用' },
        { value: 0, name: '不可用' },
        { value: -1, name: '冻结' }
      ],
      packageArray: [],
      resTotal: 0,
      resLoading: false,
      selectedItems: [],
      showTableColumns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '编号', align: 'center', key: 'code' },
        { title: '站点', align: 'center', key: 'stationName' },
        { title: '类型', align: 'center', key: 'resourcetypeName' },
        {
          title: '所属资产包',
          align: 'center',
          tooltip: true,
          key: 'packageName'
        },
        { title: '等级', align: 'center', key: 'levelName' },
        { title: '楼层', align: 'center', key: 'floor' },
        { title: '面积(㎡)', align: 'center', key: 'area' },
        {
          title: '制作尺寸(mm)',
          align: 'center',
          render: (h, params) => {
            return h(
              'span',
              `${params.row.makewidth} * ${params.row.makeheight}`
            )
          }
        },
        {
          title: '见光尺寸(mm)',
          align: 'center',
          render: (h, params) => {
            return h(
              'span',
              `${params.row.finalwidth} * ${params.row.finalheight}`
            )
          }
        },
        {
          title: '状态',
          align: 'center',
          key: 'enabled',
          render: (h, params) => {
            const status = this.statusArray.find(
              (x) => x.value === params.row.enabled
            )
            return h('span', status ? status.name : '/')
          }
        }
      ],
      editResModal: false,
      duration: 1,
      period: 1
    }
  },
  methods: {
    showModal (comId) {
      this.resDetailModal = true
      this.curTab = 'existRes'
      this.curComId = comId

      this.assetId = this.assetArray[0].id
      this.handleChangeAsset()
      this.getTableData()
    },
    getTableData () {
      getComResource({ comId: this.curComId }).then((res) => {
        this.list = res
      })
    },
    onChangeTab () {
      this.selectedItems = []
      this.selectedExistItems = []
    },
    onSelectExist (selections) {
      this.selectedExistResIds = selections.map(x => x.id)
    },
    onDelRes () {
      if (this.selectedExistResIds.length === 0) {
        this.$Notice.warning({ desc: '请选择要删除的资源！' })
        return
      }
      this.$Modal.confirm({
        title: '操作提示',
        content: '确定要删除所选资源？',
        onOk: async () => {
          const res = await deleteComResource({
            comId: this.curComId,
            resourceIds: JSON.stringify(this.selectedExistResIds)
          })
          if (res && res.success) {
            this.$Notice.success({ desc: '操作成功' })
            this.selectedExistResIds = []
            this.getTableData()
          }
        }
      })
    },
    onEditRes (row) {
      this.curExistRes = row
      this.duration = row.duration
      this.period = row.period
      this.operate = 2
      this.editResModal = true
    },
    getResData () {
      this.resLoading = true
      this.query.notInComId = this.curComId
      getResourcePage(this.query)
        .then((res) => {
          if (res && !res.errcode) {
            this.reslist = res.list
            this.resTotal = res.totalRow
            this.query.pageNumber = res.pageNumber
          } else {
            this.reslist = []
            this.resTotal = 0
            this.query.pageNumber = 1
          }
        })
        .finally(() => {
          this.resLoading = false
        })
    },
    /**
     * 获取资源类型数据
     */
    getResourceTypeData () {
      const assetIds =
        this.assetId === -1 ? this.assetArray.map((x) => x.id) : [this.assetId]
      getResourceTypeList({ assetIds: JSON.stringify(assetIds) }).then(
        (res) => {
          if (res && !res.errcode) {
            this.resourceTypeArray = res.length
              ? res.filter((x) => x.id === 1)
              : res
          } else {
            this.resourceTypeArray = []
          }
        }
      )
    },
    handleSearch () {
      this.query.pageNumber = 1
      this.getResData()
    },
    handleChangeAsset () {
      this.query.assetId = this.assetId === -1 ? undefined : this.assetId
      this.initStationArray()
      // this.getPositionData()
      this.getResourceTypeData()
      this.handleSearch()
    },
    handlePageChange (curPage) {
      this.query.pageNumber = curPage
      this.selectedItems = []
      this.getResData()
    },
    // 初始化站点选项
    initStationArray () {
      this.query.stationId = null
      let assetIds = []
      if (this.assetId <= -1) {
        this.assetArray.forEach((item) => {
          assetIds = assetIds.concat(
            this.assemblyRimAssetIds(item.rimAssetIds)
          )
        })
      } else {
        const rimAsset = this.assetArray.find((x) => x.id === this.assetId)
        if (rimAsset) {
          assetIds = this.assemblyRimAssetIds(rimAsset.rimAssetIds)
        }
      }
      // 调用mixins中的方法
      this.getStationData(assetIds)
    },
    async getPackageData () {
      if (this.query.projectId) {
        const result = await getPackageList({
          projectId: this.query.projectId
        })
        this.packageArray = result && !result.errcode ? result : []
      } else {
        this.packageArray = []
      }
    },
    onSelection (selections) {
      this.selectedItems = selections.map((x) => x.id)
    },
    onBatchAdd () {
      this.duration = 1
      this.period = 1
      this.operate = 1
      this.editResModal = true
    },
    onConfirmAdd () {
      this.$Modal.confirm({
        title: '操作提示',
        content: '确定信息无误，并提交？',
        onOk: async () => {
          const resourceInfos = this.selectedItems.map((x) => {
            return {
              resourceId: x,
              duration: this.duration,
              period: this.period
            }
          })

          const res = await addComResource({
            comId: this.curComId,
            resourceInfos: JSON.stringify(resourceInfos)
          })
          if (res && res.success) {
            this.$Notice.success({ desc: '操作成功' })
            this.curTab = 'existRes'
            this.selectedItems = []
            this.editResModal = false
            this.getResData()
            this.getTableData()
          }
        }
      })
    },
    onConfirmEditSpec () {
      this.$Modal.confirm({
        title: '操作提示',
        content: '确定信息无误，并提交？',
        onOk: async () => {
          const res = await updateComResource({
            comId: this.curComId,
            duration: this.duration,
            period: this.period,
            resourceIds: JSON.stringify([this.curExistRes.id])
          })
          if (res && res.success) {
            this.$Notice.success({ desc: '操作成功' })
            this.editResModal = false
            this.getTableData()
          }
        }
      })
    }
  }
}
</script>
